import "./SpinnerLoader.css"

const SpinnerLoader = () => {
    return (
         <div className="spinner-wrapper">
            <span className="loader"></span>
        </div>
    )
}

export default SpinnerLoader;